export const FONTS = {
    REGULAR: 'Cormorant Garamond',
    ITALIC: 'Cormorant Garamond Italic'
};
